import * as api from "api/Core";
import { GenericLogDialog, GenericLogDialogProps, ILogTranslated } from "components/GenericLogDialog";
import { JoinComponents } from "components/JoinComponents";
import { LogRecord } from "models/ApiModels";
import * as React from 'react';
import { Fragment } from 'react';
import { withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps extends GenericLogDialogProps {
    topicId: string;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TopicLogDialog extends GenericLogDialog<IProps> {

    getLog(offset: number, take: number) {
        return api.getTopicLog(this.props.topicId, offset, take);
    }

    translate(data: LogRecord[]): ILogTranslated[] {
        const { t } = this.props;
        const result: ILogTranslated[] = [];

        data.forEach((v) => {
            var j = v.jsonData;

            Object.keys(j).forEach((key) => {

                const r: ILogTranslated = {
                    name: this.defaultFieldName(key, "Topic"),
                    creationDate: v.creationDate,
                    creator: v.creator,
                    content: "?"
                };

                switch (key) {
                    case "Created":
                        r.content = null;
                        break;

                    case "Name":
                        r.content = this.valueFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "Approver":
                        r.content = this.valueFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "AllowUserSpecialist":
                        r.content = this.booleanValueTranslate(j["AllowUserSpecialist"]);
                        break;

                    case "IsPublic":
                        r.content = j[key] ? t("Topic.IsPublicTrue") : t("Topic.IsPublicFalse");
                        break;

                    case "MembersChanged":
                    case "RequiredMembersChanged":
                    case "DescendentChanged":
                    case "AscendentChanged":
                    case "AdministratorsChanged":
                        r.content = (<Fragment><JoinComponents components={t("Topic.TopicAddDelText", { added: j[key]["Added"], deleted: j[key]["Deleted"] }).split('\n')} separator={<br />} /></Fragment >);
                        break;

                    case "ApprovalRulesChanged":
                    case "SpecialistRulesChanged":
                        r.content = null;
                        break;
                }
                result.push(r);
            });
        });

        return result;
    }
}

export default withTranslation("log")(TopicLogDialog);  